/**
 * @file   url.js 对url封装的一些常用方法
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2019-09-04
 * @doc    [qs](https://github.com/ljharb/qs)
 */
import qs from 'qs';

export default {

    /**
     * 解析url
     *
     * @param  {string} url
     * @return {Object}
     */
    parse(url) {
        const a = document.createElement('a');
        a.href = url || location.href;
        return {
            url: a.href,
            protocol: a.protocol.replace(':', ''),
            hostname: a.hostname,
            path: a.pathname,
            port: a.port,
            querystring: a.search.replace('?', ''),
            params: qs.parse(a.search, {
                ignoreQueryPrefix: true
            }),
            hash: a.hash.replace('#', '')
        };
    }
};
